export const createSettingsDeliverableTypesRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
